import { render, staticRenderFns } from "./BlockPriceListDuplicate.vue?vue&type=template&id=c22cc7d2&scoped=true"
import script from "./BlockPriceListDuplicate.vue?vue&type=script&lang=js"
export * from "./BlockPriceListDuplicate.vue?vue&type=script&lang=js"
import style0 from "./BlockPriceListDuplicate.vue?vue&type=style&index=0&id=c22cc7d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22cc7d2",
  null
  
)

export default component.exports